import {
  Component,
  Input,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector:    'app-panel',
  standalone:  true,
  imports:     [CommonModule],
  templateUrl: './panel.component.html',
  styleUrls:   ['./panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PanelComponent {

  /** Titre affiché dans l'en-tête du panel */
  @Input() title = '';

  /**
   * Rend la zone footer (boutons bas de panel).
   * Mettre à true et projeter le contenu avec l'attribut [panel-foot].
   */
  @Input() hasFooter = false;
}
